import { useLanguage } from '../providers/preferenceProvider';
import { fetchUserPreferences, saveUserPreferences } from '../api/user-preferences-api';
import { useTheme } from '../providers/preferenceProvider';
import { useEffect, useState } from 'react';
import '../css/settings.css';
import { useConfig } from '../providers/configProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons';

const Settings = () => {
  const { t, lang, changeLanguage, getAvailableLanguages } = useLanguage();
  const [langs, setLangs] = useState([]);
  const { theme, setTheme } = useTheme();
  const { config } = useConfig();
  const [emailBookings, setEmailBookings] = useState(true);
  const [emailInvitations, setEmailInvitations] = useState(true);

  const userId = config?.user?.id;

  useEffect(() => {
    if (!userId) return;
  
    fetchUserPreferences(userId).then(prefs => {
      if (prefs.bookingEmail) handleEmailBookingsChange(prefs.bookingEmail === "true");
      if (prefs.invitationsEmail) handleEmailInvitationsChange(prefs.invitationsEmail === "true");
    }).catch(console.error);
  }, [userId]);
  
  useEffect(() => {
    setLangs(getAvailableLanguages());
  }, [getAvailableLanguages]);

  const handleEmailBookingsChange = (value) => {
    setEmailBookings(value);
    saveUserPreferences(userId, { bookingEmail: value });
  };

  const handleEmailInvitationsChange = (value) => {
    setEmailInvitations(value);
    saveUserPreferences(userId, { invitationsEmail: value });
  };

  const icsUrl = process.env.REACT_APP_API_BASE_URL + "/user/ical/" + config.user.id;
  const webcalUrl = icsUrl.replace(/^https?:\/\//, 'webcal://');

  return (
    <>
      <main className="main-container">
        <div className="main-box">
          <div className="main-header">{t.settings}</div>

          <div className="sub-header">{t.preferences}</div>
          <div className="preferences-item">
            <label htmlFor="language-select">{t.language}</label>
            <select id="theme-select" value={lang} onChange={(e) => changeLanguage(e.target.value)}>
              {langs.map((code) => (
                <option key={code} value={code}>
                  {t.language_codes[code]}
                </option>
              ))}
            </select>
          </div>
          <div className="preferences-item">
            <label htmlFor="theme-select">{t.theme}</label>
            <select id="theme-select" value={theme} onChange={(e) => setTheme(e.target.value)}>
              <option value="light">{t.themes.light_mode}</option>
              <option value="dark">{t.themes.dark_mode}</option>
              <option value="barbie">{t.themes.barbie_mode}</option>
              <option value="smurf">{t.themes.smurf_mode}</option>
              <option value="shrek">{t.themes.shrek_mode}</option>
            </select>
          </div>

          <div className="sub-header mt-2">{t.notifications}</div>
          <div className="ml-2 max-md:ml-7">
            <label htmlFor="email-bookings">{t.email_bookings}</label>
            <label className="switch">
              <input
                type="checkbox"
                id="email-bookings"
                checked={emailBookings}
                onChange={(e) =>+  handleEmailBookingsChange(e.target.checked)}
              />
              <span className="slider"></span>
            </label>
          </div>
          <div className="ml-2 max-md:ml-7">
            <label htmlFor="email-invitations">{t.email_invitations}</label>
            <label className="switch">
              <input
                type="checkbox"
                id="email-invitations"
                checked={emailInvitations}
                onChange={(e) => handleEmailInvitationsChange(e.target.checked)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="sub-header mt-2">{t.third_party_integrations}</div>
          <div className='mt-4 '>
            <a className="action-button ml-2 max-md:ml-7" href={webcalUrl} target="_blank" rel="noopener noreferrer" >
              <FontAwesomeIcon icon={faCalendar} /> {t.sync_calendar}
            </a>
            <div className="calendar-warning ml-2 mb-2 max-md:ml-7 max-md:mr-4 ">
              Note: Calendar sync works best with Apple Calendar, Outlook, and some Android apps. Not all devices or browsers support webcal links. If it doesn't work, try
              <a href={icsUrl} target="_blank" rel="noopener noreferrer"> downloading the .ics file and importing it manually</a>.
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Settings;